import 'swiper/css/bundle';
import Swiper from 'swiper';


import './featured-posts.scss';

const featuredPosts = () => {
    let args = {
        slidesPerView: "auto",
        spaceBetween: 10
    };

    let featuredSwiper = new Swiper(document.querySelector('.pressMobileSwiper'), args);
}

export default featuredPosts;
